import ReactAutosuggest from 'react-autosuggest';
import { deprecated } from '../constants/texts';

export default class ReactAutoSuggestDeprecated extends React.PureComponent {
  componentDidMount() {
    console.warn(
      'React AutoSuggest -- was removed completely, using legacy api, use Edocat/Components/Select/Authority instead'
    );
  }

  render() {
    return <ReactAutosuggest {...this.props} />;
  }
}
